import React from 'react';
import {
  View,
  Image,
  TextStyle,
  ViewStyle,
  StyleSheet,
  ImageStyle,
} from 'react-native';
import {Text} from 'ui-kits';
import {ImageSource} from 'react-native-vector-icons/Icon';
import colors from 'theme/Colors';
import {spacing} from 'theme/Units';

type propTypes = Readonly<{
  text: string;
  imageSource: ImageSource;
}>;
export function ComingSoon({text, imageSource}: propTypes) {
  return (
    <View style={styles.container}>
      <Image style={styles.image} source={imageSource} />
      <View style={styles.main}>
        <Text style={styles.header}> Coming Soon... </Text>
        <Text style={styles.subHeader}>{text}</Text>
      </View>
    </View>
  );
}
type comingSoonType = {
  container: ViewStyle;
  main: ViewStyle;
  header: TextStyle;
  subHeader: TextStyle;
  image: ImageStyle;
};
const styles: comingSoonType = StyleSheet.create({
  container: {
    backgroundColor: colors.palette.white,
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingVertical: spacing['8'],
  },
  main: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing['1'],
  },
  header: {
    color: colors.palette.brandBlue,
    fontSize: 24,
    fontWeight: 600,
  },
  subHeader: {
    fontWeight: 400,
    color: colors.palette.black,
  },
  image: {
    width: 300,
    height: 300,
    resizeMode: 'contain',
  },
});
